import { z } from 'zod';
const FourCsImplicationSchema = z.object({
    topic: z.string().describe('The topic/name of the implication'),
    description: z.string().describe('The description of the implication'),
});
const FourCsTruthSchema = z.object({
    recommended: z
        .boolean()
        .describe('True if the truth is recommended. Only one truth should be recommended per C.'),
    truth: z.string().describe('The truth statement. Must be concise, actionable, and specific.'),
});
const CategoryDataSchema = z.object({
    guidingQuestions: z
        .array(z.string())
        .describe('The guiding questions specific to this C (array of strings)'),
    findings: z.array(z.string()).describe('The findings specific to this C (array of strings)'),
    implications: z
        .array(FourCsImplicationSchema)
        .describe('The implications specific to this C (array of objects with topic and description)'),
    truths: z
        .array(FourCsTruthSchema)
        .describe('The truths specific to this C (array of objects with recommended and truth)'),
});
export const FourCsWidgetSchema = z.object({
    fourCs: z
        .object({
        category: CategoryDataSchema,
        consumer: CategoryDataSchema,
        company: CategoryDataSchema,
        cultural: CategoryDataSchema,
    })
        .describe("The four C's as an object with keys category, consumer, company, and cultural. Each key holds guidingQuestions, findings, implications, and truths."),
    validation: z
        .object({
        confidenceScore: z
            .string()
            .describe("The confidence of the four C's expressed as a concise sentence (e.g. 'Strongly validated at the directional level'), etc."),
        supportingEvidence: z
            .array(z.string())
            .describe("The supporting evidence for the four C's. Must be source-backed. (array of strings)"),
        redFlags: z
            .array(z.string())
            .describe("The red flags for the four C's. Must be specific and actionable. (array of strings)"),
        recommendations: z
            .array(z.string())
            .describe("The recommendations for the four C's. Must be specific and actionable. (array of strings)"),
    })
        .describe("The validation of the four C's"),
});
export const FourCsWidgetKey = 'four-cs-widget:v1';
export const FourCsWidgetKind = 'insight';
